import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material";

export default function BreakStartDialogue(props) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        style={{
          borderRadius: "20%",
          // padding: "1.2rem 1.8rem",
          width: "6rem",
          height: "4.5rem",
          textTransform: "capitalize",
          fontSize: "1.2rem",
          padding: "1rem 1rem",
          lineHeight: "1.5rem",
          fontWeight: "bold",
          margin: "0 1rem",
          color: theme.palette.text.secondary,
        }}
        onClick={handleClickOpen}
      >
        Start Break
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            backgroundColor: theme.palette.dialog.paper,
            borderRadius: "1rem",
          },
        }
        }
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" , color: theme.palette.text.primary, fontSize: "1.5rem"}}>
          Do you want to start a break?
        </DialogTitle>
        <DialogActions
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            style={{
              marginLeft: "1rem",
              marginBottom: "1rem",
              backgroundColor: theme.palette.button.grey,
              color: "black",
              fontWeight: "bold",
              fontSize: "1.2rem",
              padding: "0.4rem 1.5rem",
            }}
            variant="contained"
            onClick={handleClose}
          >
            Disagree
          </Button>
          <Button
            style={{
              marginRight: "1rem",
              marginBottom: "1rem",
              fontWeight: "bold",
              fontSize: "1.2rem",
              padding: "0.4rem 1.5rem",
              color: theme.palette.text.primary,
                      backgroundColor: theme.palette.success.main
            }}
            variant="contained"
            onClick={props.startBreak}
            autoFocus
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
